/** @jsxImportSource @emotion/react */
import { useRef } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

import { useFilterPanelToggleContext } from '../../context/filterPanelToggle';
import useScrollTop from '../../hooks/useScrollTop';
import FiltersPanel from '../FiltersPanel';
// import FiltersToggle from '../FiltersToggle';
import Navigation from '../Navigation';
import SkipToMainButton from '../SkipToMainButton';
import useStyles from './styles';

const PageWithFilters = ({
  children,
  pageName,
  showSkipLink,
  setShowSkipLink,
  skipCounter,
  setSkipCounter,
}) => {
  const pageRef = useRef();
  useScrollTop(pageRef);
  const styles = useStyles();
  const {
    isFilterPanelToggled,
    setFilterPanelToggle,
    //isFilterEnabled,
    setFilterEnabledTab,
  } = useFilterPanelToggleContext();
  /* Commenting this useEffect as creating problem with new filter  */
  // const filtersToggleBtnRef = useRef(null);
  // useEffect(() => {
  //   filtersToggleBtnRef.current.focus();
  // }, [isFilterPanelToggled]);

  const location = useLocation();
  const currentPage =
    location.pathname === '/'
      ? 'homepage'
      : location.pathname.startsWith('/recommendations')
      ? 'recommendationspage'
      : location.pathname.startsWith('/club')
      ? 'clubpage'
      : location.pathname.startsWith('/team')
      ? 'teampage'
      : 'other';

  return (
    <div className="spa-scroll-top-fix" ref={pageRef} tabIndex={-1}>
      <div css={styles.navigation}>
        {currentPage === 'recommendationspage' && (
          <>
            <div
              tabIndex={0}
              onFocus={() => setShowSkipLink(true)}
              style={{
                position: 'absolute',
                width: '1px',
                height: '1px',
                overflow: 'hidden',
              }}
            />
            <SkipToMainButton
              isVisible={showSkipLink}
              setIsVisible={setShowSkipLink}
              setSkipCounter={setSkipCounter}
              currentPage={currentPage}
            />
          </>
        )}
        <Navigation withBorder skipCounter={skipCounter} />
        {/* Commenting this FiltersToggle as creating problem with new filter  */}
        {/* <FiltersToggle
          isToggled={isFilterPanelToggled}
          onClick={() => {
            setFilterPanelToggle(!isFilterPanelToggled);
            setFilterEnabledTab(!isFilterEnabled);
          }}
          ref={filtersToggleBtnRef}
        /> */}
      </div>
      <FiltersPanel
        page={pageName}
        isToggled={isFilterPanelToggled}
        onClose={() => {
          setFilterEnabledTab(false);
          setFilterPanelToggle(false);
        }}
      />
      {children}
      {isFilterPanelToggled && <div css={styles.overlay} />}
    </div>
  );
};

export default PageWithFilters;
